export default __webpack_public_path__ + "static/media/Startup.3bfa22cb.png";